import React from "react";

export default function PriceOfferChildGrandUpsellExplainer(props) {
  // PROPS COMING FROM PriceOfferChildTimeRestrictedDiscounted
  const { isPending } = props;

  return (
    <>
      <p className="marb1">
        Merhaba Sayın {isPending.pendingOrders[0].deliveryContact.firstName}{" "}
        {isPending.pendingOrders[0].deliveryContact.lastName}
      </p>
      <p>
        Paketlenmek üzere beklemede olan{" "}
        <span className="marupside1 slightlyyellowbck">
          {isPending.pendingOrders[0].orderId}
        </span>{" "}
        numaralı siparişiniz nedeni ile indirimli ek sipariş oluşturma hakkınız
        bulunuyor.
      </p>
      <p className="marupside1">
        Oluşturacağınız yeni siparişler ana siparişiniz ile birlikte paketlenir
        ve Yurtiçi kargoya teslim edilir.
      </p>
      <p className="lightredbck">
        Ana sipariş paketlendiği an sistemlerimiz güncellenir ve indirim hakkı
        sona erer.
      </p>
      <p className="marupside1">
        Paketleme için belirli bir süre yoktur. beddo™ paketleme ekibi, onaylı
        siparişlerin tümünü hızlıca paketlemek için çaba gösterir.
      </p>
      <p className="marb1">
        İndirim hakkınızı kaçırmamak için hızlı davranmanızı öneririz.
      </p>
      <p className="w100p margintop-1">
        beddo™ rahatını sevdiklerinize de yaşatmak için ya da farklı mekanlarda
        elinizin altında her an hazır bir beddo™ olması için ek siparişler
        oluşturun.
      </p>
    </>
  );
}
